<template>
  <v-btn
    large
    rounded
    class="text-center quick-link-button"
    @click="openFactSheet()"
  >
    <v-icon left x-large class="quick-link-icon">mdi-clipboard-check</v-icon>
    <h3>FACT SHEET</h3>
  </v-btn>
</template>

<script>
export default {
  name: "FactBtn",
  methods: {
    openFactSheet() {
      window.open(
        "https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/I-10_Calcasieu_FactSheet.pdf",
        "_blank"
      );
    }
  }
};
</script>

<style scoped></style>
